import type { ReactNode } from "react";
import React from "react";
import { Field } from "redux-form";

import { Grid } from "@braintrust/braintrust-ui-components";
import { useGetEmployerCurrentOfferDepositQuery } from "@js/apps/employer/hooks/get-employer-current-offer-deposit";
import { RadioListField } from "@js/forms/fields";
import type { PaymentMethod } from "@js/types/payments";

import type { PaymentMethodListItemProps } from "./item";
import { PaymentMethodListItem } from "./item";

type PaymentMethodsListProps = {
  paymentMethods: PaymentMethod[];
} & Omit<
  PaymentMethodListItemProps,
  "paymentMethod" | "isDeleteOptionDisabled"
>;

export const PaymentMethodsList = ({
  paymentMethods,
  ...props
}: PaymentMethodsListProps) => {
  const { data: offerDeposit } = useGetEmployerCurrentOfferDepositQuery({
    skip: !paymentMethods.length,
  });

  if (!paymentMethods.length) {
    return null;
  }

  const currentOfferDeposit = offerDeposit?.current_offer_deposit;

  return (
    <Grid container spacing={4} data-testid="payment-methods">
      {paymentMethods.map((paymentMethod) => {
        const isDeleteOptionDisabled =
          !!currentOfferDeposit &&
          currentOfferDeposit.payment_method_id === paymentMethod.id;

        return (
          <Grid
            size={{
              lg: 10,
              xs: 12,
            }}
            key={paymentMethod.id}
            data-testid={`payment-method-${paymentMethod.content_type}`}
          >
            <PaymentMethodListItem
              {...props}
              paymentMethod={paymentMethod}
              isDeleteOptionDisabled={isDeleteOptionDisabled}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

type SelectablePaymentMethodsListProps = {
  paymentMethodsOptions: {
    value: PaymentMethod;
    label: ReactNode;
  }[];
  disabled?: boolean;
  name?: string;
};

export const SelectablePaymentMethodsList = ({
  paymentMethodsOptions,
  disabled,
  name,
}: SelectablePaymentMethodsListProps) => {
  return (
    <Field
      name={name || "payment_method"}
      label="Payment method"
      component={RadioListField}
      options={paymentMethodsOptions}
      disabled={disabled}
    />
  );
};
